<template>
  <div id="weather-map-wrapper">
     <div
    v-show="hoverTooltip.visible"
    class="hover-tooltip"
    :style="{ left: hoverTooltip.x + 'px', top: hoverTooltip.y + 'px' }"
  >
    {{ hoverTooltip.text }}
  </div>
    <div ref="map3dweather" id="weather-map-container"   :class="{ 'weather-enabled': weatherActive }"></div>
    <button id="routing-button" @click="startRouting">Routing</button>
    <RoutingService
      v-if="routingEnabled"
      :kml-url="kmlUrl"
      @routeLoaded="onRouteLoaded"
      @error="onRoutingError"
    />
  </div>
</template>


<script>
import M2wApi from "@/services/m2w_api";
import { initMTKMap, getMTKMap, destroyMTKMap } from "@/services/map/mtkMapManager";
// import convertPoisToGeoJSON from "@/convertPoisToGeoJSON";

const DBG = {
  init:   true,   
  events: true,   
  camera: true,  
};

const TAG = "WeatherMTK";
const log = {
  start: (what, extra={}) => console.groupCollapsed(`%c[${TAG}] ▶ ${what}`, "color:#0af", extra),
  ok:    (msg, extra={}) => console.log(`%c[${TAG}] ✓ ${msg}`, "color:#0a0", extra),
  warn:  (msg, extra={}) => console.warn(`[${TAG}] ⚠ ${msg}`, extra),
  err:   (msg, extra={}) => console.error(`[${TAG}] ✖ ${msg}`, extra),
  end:   () => console.groupEnd()
};

const DAYTIME_I18N = {
  ro: { today:"Astăzi", tomorrow:"Mâine", months:["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"] },
  de: { today:"Heute",  tomorrow:"Morgen", months:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"] },
  en: { today:"Today",  tomorrow:"Tomorrow", months:["January","February","March","April","May","June","July","August","September","October","November","December"] }
};

export default {
  
  /* eslint-disable prettier/prettier */
  /* eslint-disable no-undef */
  // /* global MTK */

  name: "WeatherMTK",
  props: {
    lat: { type: Number, required: true },
    lng: { type: Number, required: true },
    zoom: { type: Number, default: 0 },
    poisGeoJSON: { type: Object, default: null },
    startWithWeather: { type: Boolean, default: false },
    projectId: { type: [String, Number], default: null },
    hideUi: { type: Boolean, default: false },
  },
  data() {
    return {
      map: null,
      routingEnabled: false,
      isWeatherLayerMounted: false,
      flightAnimation: null,
      isSingleLineSelected: false,
      weatherControl: null,
      weatherActive: false,
      currentActivePoiId: null,
      currentSelectedPolyline: null,
      geolocateControl: null,
      firstStartPozition:null,
      lastKnownMarkerPosition: null,
      lastStopDistance: 0,
      staticStopMarker: null,
      elevationData: null,
      lastProgress: 0,
      singlePoiApplied: false,
      streetLineLayer3D: null, 
      hnrMarker3D: null, 
      startMarker3D: null,
      stopMarker3D: null,
      homeView: null, 
      booting: false, 
      skipNextAutoFit: false,
      cameraBusy: false,
      userPanning: false,
      suppressAutoFocus: false, 
      clickMoveLock: false,          
      lastClickAt: 0,                
      programmaticSilenceUntil: 0,
      hasResetAfterFlight: false,
      hoverTooltip: { visible: false, x: 0, y: 0, text: "" },
      geolocationMarker: null,
      //nou26.01
      elevationHostEl: null,
  flightHostEl: null,


    };
  },
  watch: {
    lat() { this.skipNextAutoFit = true; },
    lng() { this.skipNextAutoFit = true; },
    poisGeoJSON: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (this.skipNextPoisWatch) { this.skipNextPoisWatch = false; return; }
        if (!newVal || !Array.isArray(newVal.features)) { this.clearPOIsFromMap(false); return; }
        const cleanPois = this.normalizeFeatureCollection(newVal);
        if (!cleanPois || !cleanPois.features.length) { this.clearPOIsFromMap(false); return; }

        const drawOnly = () => this.addPoisOn3DMap(cleanPois);
        const wait = setInterval(() => {
          if (this.mtkMap?.gl?.isStyleLoaded?.()) { clearInterval(wait); this.$nextTick(drawOnly); }
        }, 150);
      }
    },
  //   "$i18n.locale"() {
  //   // când schimbi limba din settings
  //   this.$nextTick(() => {
  //     this._translateDaytimeSoon();
  //   });
  // },
  "$i18n.locale"(v) {
    console.log("[i18n.locale changed]", v);
    this._translateDaytimeSoon();
  }
  },
  

  mounted() {
    window._weatherMTK = this;
    this.$root.weatherActive = true;
    this.$root.$on("triggerGeolocationIn3D", this.triggerGeolocation);
    //nou26.01
    this.$root.$on("mtkElevationHostReady", (el) => {
  this.elevationHostEl = el;
  this.ensureElevationProfile();   
});

this.$root.$on("mtkFlightHostReady", (el) => {
  this.flightHostEl = el;
  this._mountFlightControlToHost(); 
});

this.$root.$on("mtkUiHostsReady", () => {
  this.ensureElevationProfile();
  this._mountFlightControlToHost();
});


    this._onClearAll3D = () => this.clearPOIsFromMap(true);
    this.$root.$on("clearAll3D", this._onClearAll3D);

    this.$root.$on("clearFlightPolyline", () => {
      if (this.flightControl) {
        try { this.flightControl.stop(); this.flightControl.remove(); } 
        catch (e) { console.warn("stop FlightControl:", e); }
        this.flightControl = null;
      }
      if (this.currentSelectedPolyline) {
        try { this.currentSelectedPolyline.remove(); } 
        catch (e) { console.warn("remove polyline:", e); }
        this.currentSelectedPolyline = null;
      }
    });

    this.$nextTick(() => {
      const target = this.$refs.map3dweather;
      this.debugPrintInitContext(target, [this.lng, this.lat], this.zoom, { preserveDrawingBuffer: true, antialias: true });

      initMTKMap(target, [this.lng, this.lat], this.zoom, { preserveDrawingBuffer: true, antialias: true });

      const waitForMap = setInterval(() => {
        this.mtkMap = getMTKMap();
        if (!this.mtkMap) return;


        clearInterval(waitForMap);
        const gl = this.mtkMap.gl;

        this.debugBindCoreEvents(gl);
        this.debugWrapCamera(gl);

        // installNoZoomWhileDragging(gl, () => gl.getZoom(), (z) => gl.jumpTo({ zoom: z }), gl);
        // installPanFlags(gl, (v) => { this.userPanning = v; });
        const isTouchDevice =
          "ontouchstart" in window ||
          navigator.maxTouchPoints > 0 ||
          navigator.msMaxTouchPoints > 0;

        if (!isTouchDevice) {
          installNoZoomWhileDragging(
            gl,
            () => gl.getZoom(),
            (z) => gl.jumpTo({ zoom: z }),
            gl
          );
        }

        installPanFlags(gl, (v) => { this.userPanning = v; });

        const emitViewThrottled = (() => {
          let t = null;
          return (force = false) => {
            if (!force && this._isSilentNow()) return;
            const c = gl.getCenter(); const z = gl.getZoom();
            const payload = { lat: c.lat, lng: c.lng, lon: c.lng, zoom: z };
            const send = () => {
              this.$emit("updateView", payload);                
              this.$root.$emit("mtkViewChanged", payload);     
            };
            if (force) { send(); return; }
            if (t) return;
            t = setTimeout(() => { t = null; send(); }, 150);
          };
        })();

        gl.on("moveend", () => emitViewThrottled(true));

        this.mtkMap.once("idle", async () => {
          gl.resize();
          this.setupFlightControl();

          const handledFromUrl = await this.loadSinglePoiFromUrl();
          let handledFromProp = false;
          if (!handledFromUrl && this.singlePoiFromApi) {
            handledFromProp = await this.applySinglePoiFromApiPayload(this.singlePoiFromApi);
          }
          if (!handledFromUrl && !handledFromProp && this.poisGeoJSON?.features?.length) {
            const fc = this.normalizeFeatureCollection(this.poisGeoJSON);
            if (fc?.features?.length) {
              this.skipNextPoisWatch = true;
              this.addPoisOn3DMap(fc);
            }
          }
          emitViewThrottled(true);
          this.$emit("weatherMtkMounted");
          
        });

        this.$root.$on("poiSelectedFromList", (feature) => this.handleFeatureFromList(feature));
      }, 100);
    });
  },

  beforeDestroy() {
    this.$root.weatherActive = false;
    // this.$root.$off("startFlightControl", this.onExternalStartFlight);
    // this.$root.$off("stopFlightControl", this.onExternalStopFlight);
    this.$root.$off("triggerGeolocationIn3D", this.triggerGeolocation);
    this.$root.$off("clearAll3D", this._onClearAll3D);

    //nou26.01
    this.$root.$off("mtkElevationHostReady");
this.$root.$off("mtkFlightHostReady");
this.$root.$off("mtkUiHostsReady");

    
    destroyMTKMap();
  },

  methods: {
    _translateDaytimeSoon() {
  clearTimeout(this._daytimeT);
  this._daytimeT = setTimeout(() => {
    this.translateDaytimeControl();
  }, 50);
},

// translateDaytimeControl() {
//   const locale = this.$i18n.locale || "en";
//   const t = DAYTIME_I18N[locale] || DAYTIME_I18N.en;

//   const buttons = document.querySelectorAll(".mtk-daytime-control-button");

//   buttons.forEach(btn => {
//     const txt = btn.innerText.trim();

//     if (txt === "Today") btn.innerText = t.today;
//     else if (txt === "Tomorrow") btn.innerText = t.tomorrow;
//     else {
//       const m = txt.match(/^(\d{1,2})\s+([A-Za-z]+)$/);
//       if (m) {
//         const day = m[1];

//         const monthMap = {
//           January:0, February:1, March:2, April:3, May:4, June:5,
//           July:6, August:7, September:8, October:9, November:10, December:11
//         };

//         const mi = monthMap[m[2]];
//         if (mi != null) {
//           btn.innerText = `${day} ${t.months[mi]}`;
//         }
//       }
//     }
//   });
// }
translateDaytimeControl() {
  const locale = this.$i18n.locale || "en";
  const t = DAYTIME_I18N[locale] || DAYTIME_I18N.en;

  const buttons = document.querySelectorAll(".mtk-daytime-control-button");

  const isToday = (txt) => ["Today", "Astăzi", "Heute"].includes(txt);
  const isTomorrow = (txt) => ["Tomorrow", "Mâine", "Morgen"].includes(txt);

  // 🔥 reverse map: ORICE limbă → index lună
  const monthIndex = {};
  Object.values(DAYTIME_I18N).forEach(lang => {
    lang.months.forEach((m, i) => {
      monthIndex[m.toLowerCase()] = i;
    });
  });

  buttons.forEach((btn) => {
    const txt = btn.innerText.trim();

    // Today / Tomorrow
    if (isToday(txt)) {
      btn.innerText = t.today;
      return;
    }

    if (isTomorrow(txt)) {
      btn.innerText = t.tomorrow;
      return;
    }

    // 🔥 Date (ex: "5 February", "5 Februar", "5 Februarie")
    const m = txt.match(/^(\d{1,2})\s+(.+)$/);
    if (!m) return;

    const day = m[1];
    const monthName = m[2].toLowerCase();

    const mi = monthIndex[monthName];

    if (mi != null) {
      btn.innerText = `${day} ${t.months[mi]}`;
    }
  });
}


,

    //mou26.01
    _mountFlightControlToHost() {
  if (!this.flightControl || !this.flightControl._container) return;
  if (!this.flightHostEl) return;

  this.flightHostEl.innerHTML = "";
  this.flightHostEl.appendChild(this.flightControl._container);

  // opțional: compat cu ce aveai înainte
  this.$root.$emit("mtkFlightControlReady", this.flightControl._container);
}
,
    resetCameraTo2DNorth() {
  const gl = this.mtkMap?.gl;
  if (!gl) return;

  try {
    gl.easeTo({
      pitch: 0,
      bearing: 0,   // Nord sus
      duration: 600 // 0.6s animație de revenire
    });
  } catch (e) {
    console.warn("[WeatherMTK] resetCameraTo2DNorth failed:", e);
  }
},

    focusFeatureCollection(fc, opts = {}) {
      const safe = this.normalizeFeatureCollection(fc);
      if (!safe || !safe.features?.length) return;
      const boundsAll = new window.maplibregl.LngLatBounds();
      const allCoords = [];
      safe.features.forEach(f => {
        const g = f.geometry; if (!g) return;
        const push = (c) => { boundsAll.extend(c); allCoords.push(c); };

        if (g.type === "Point") push(g.coordinates);
        else if (g.type === "LineString") g.coordinates.forEach(push);
        else if (g.type === "MultiLineString") g.coordinates.flat().forEach(push);
        else if (g.type === "Polygon") g.coordinates[0].forEach(push);
        else if (g.type === "MultiPolygon") g.coordinates.flat(2).forEach(push);
      });

      const ctx = {
        ok: true,
        featuresCount: safe.features.length,
        firstFeature: safe.features[0],
        allCoords,
        boundsAll: boundsAll.isEmpty() ? null : boundsAll
      };

      this.focusMapAfterAdding(ctx, {
        paddingMulti: this.getFitPadding(),
        durationMulti: 900,
        paddingSingle: this.getFitPadding(),
        durationSingle: 1200,
        ...opts
    });
    },

    focusFeatureOnly(feature) {
      this.focusFeatureOnce(feature);
    },
    _markProgrammatic(ms = 900) {           
      this.programmaticSilenceUntil = performance.now() + ms;
    },
    _isSilentNow() {
      return performance.now() < this.programmaticSilenceUntil;
    },
    onOLViewChanged({ lat, lng, zoom, instant = true } = {}) {
      const gl = this.mtkMap?.gl;
      if (!gl || typeof lat !== "number" || typeof lng !== "number") return;
      this._markProgrammatic(900);
      try {
        if (instant) {
          gl.jumpTo({ center: [lng, lat], zoom: typeof zoom === "number" ? zoom : gl.getZoom() });
        } else {
          gl.easeTo({ center: [lng, lat], zoom: typeof zoom === "number" ? zoom : gl.getZoom(), duration: 600 });
        }
      } catch (e) {
        console.warn("onOLViewChanged failed:", e);
      }
    },
    _getBestLineCoordsFromFeatures(features) {
      const lines = [];

      const hav = (a, b) => {
        const toRad = d => d * Math.PI / 180, R = 6371000;
        const dLat = toRad(b[1]-a[1]), dLng = toRad(b[0]-a[0]);
        const s1 = Math.sin(dLat/2), s2 = Math.sin(dLng/2);
        const aa = s1*s1 + Math.cos(toRad(a[1]))*Math.cos(toRad(b[1]))*s2*s2;
        return 2*R*Math.asin(Math.min(1, Math.sqrt(aa)));
      };
      const lengthOf = (coords) => {
        let L = 0;
        for (let i = 1; i < coords.length; i++) L += hav(coords[i-1], coords[i]);
        return L;
      };

      for (const f of features) {
        const g = f?.geometry; if (!g) continue;
        if (g.type === "LineString" && g.coordinates?.length >= 2) {
          lines.push(g.coordinates);
        }
        if (g.type === "MultiLineString" && Array.isArray(g.coordinates)) {
          g.coordinates.forEach(seg => { if (seg?.length >= 2) lines.push(seg); });
        }
      }

      if (!lines.length) return null;
      let best = lines[0], bestL = lengthOf(best);
      for (let i = 1; i < lines.length; i++) {
        const L = lengthOf(lines[i]);
        if (L > bestL) { best = lines[i]; bestL = L; }
      }
      return best;
    },
    async focusFeatureOnce(feature) {
      if (this.clickMoveLock) return;

      const now = performance.now();
      if (now - this.lastClickAt < 300) return; 
      this.lastClickAt = now;

      const gl = this.mtkMap?.gl;
      const g  = feature?.geometry;
      if (!gl || !g) return;

      this.clickMoveLock = true;
      this._markProgrammatic(900); 

      const end = () => setTimeout(() => { this.clickMoveLock = false; }, 0);
      const epsDeg = 1e-5;  // ~1 m

      try {
        if (g.type === "Point") {
          const [lng, lat] = g.coordinates;
          const cur = gl.getCenter(), cz = gl.getZoom();
          const sameCenter = Math.abs(cur.lng - lng) < epsDeg && Math.abs(cur.lat - lat) < epsDeg;
          if (sameCenter) { end(); return; }

          gl.flyTo({
            center: [lng, lat],
            zoom: cz,          
            speed: 4,
            curve: 1.05,
          });
        } else {
          const b = new window.maplibregl.LngLatBounds();
          const ext = (c) => b.extend(c);

          if (g.type === "LineString")       g.coordinates.forEach(ext);
          if (g.type === "MultiLineString")  g.coordinates.flat().forEach(ext);
          if (g.type === "Polygon")          g.coordinates.forEach(r => r.forEach(ext));
          if (g.type === "MultiPolygon")     g.coordinates.forEach(p => p.forEach(r => r.forEach(ext)));

          if (b.isEmpty()) { end(); return; }

          gl.fitBounds(b, {
            padding: 100,
            duration: 1200,
            linear: false,
            easing: t => 1 - Math.pow(1 - t, 2)
          });
        }
        await this.$nextTick();
        this.$emit("poi-click", {
          id: feature?.properties?.id ?? feature?.id,
          name: feature?.properties?.name,
          parent: { id: feature?.properties?.parent_id ?? feature?.properties?.parent?.id },
          geom: feature?.geometry,
          properties: feature?.properties
        });

        gl.once?.("moveend", () => setTimeout(() => { this.clickMoveLock = false; }, 50));
      } catch (e) {
        console.warn("focusFeatureOnce error:", e);
        end();
      }
    },

    debugPrintInitContext(targetEl, initCenter, initZoom, initOpts) {
  if (!DBG.init) return;
  try {
    const br = targetEl?.getBoundingClientRect?.() || {};
    const ctx = {
      componentProps: { lat: this.lat, lng: this.lng, zoom: this.zoom },
      homeCenterProp: this.homeCenter,
      route: { path: this.$route?.path, query: this.$route?.query },
      containerPx: { w: Math.round(br.width||0), h: Math.round(br.height||0) },
      dpr: window.devicePixelRatio || 1,
      initArgs: { center: initCenter, zoom: initZoom, opts: initOpts },
      time: new Date().toISOString(),
    };
    console.groupCollapsed("%c[WeatherMTK] ▶ MTK INIT CONTEXT", "color:#08f");
    console.table(ctx);
    console.groupEnd();
  } catch (e) {
    console.warn("[WeatherMTK] debugPrintInitContext fail", e);
  }
    },

    debugWrapCamera(gl) {
      if (!DBG.camera || !gl) return;
      const wrap = (name, fn) => (...args) => {
        const before = {
          center: gl.getCenter && gl.getCenter(),
          zoom:   gl.getZoom && gl.getZoom(),
          pitch:  gl.getPitch && gl.getPitch(),
          bearing:gl.getBearing && gl.getBearing(),
        };
        console.groupCollapsed(`%c[MTK.Camera] ${name}`, "color:#f60");
        console.log("args:", args);
        console.log("before:", before);
        console.trace("stack");
        try {
          const ret = fn.apply(gl, args);
          // after next frame, 
          setTimeout(() => {
            const after = {
              center: gl.getCenter && gl.getCenter(),
              zoom:   gl.getZoom && gl.getZoom(),
              pitch:  gl.getPitch && gl.getPitch(),
              bearing:gl.getBearing && gl.getBearing(),
            };
            console.log("after:", after);
            console.groupEnd();
          }, 0);
          return ret;
        } catch (e) {
          console.error(`[MTK.Camera] ${name} error`, e);
          console.groupEnd();
          throw e;
        }
      };

      const camFns = ["flyTo","fitBounds","jumpTo","easeTo","setCenter","setZoom","panTo"];
      camFns.forEach(n => {
        if (typeof gl[n] === "function" && !gl[`__wrapped_${n}`]) {
          gl[`__orig_${n}`] = gl[n];
          gl[n] = wrap(n, gl[n]);
          gl[`__wrapped_${n}`] = true;
        }
      });
    },
    debugBindCoreEvents(gl) {
      if (!DBG.events || !gl?.on) return;
      const pr = (e, extra={}) => {
        const c = gl.getCenter ? gl.getCenter() : null;
        const payload = {
          zoom:    gl.getZoom?.(),
          lat:     c?.lat,
          lng:     c?.lng,
          pitch:   gl.getPitch?.(),
          bearing: gl.getBearing?.(),
          ...extra,
        };
        console.log(`[MTK ${e}]`, payload);
      };

      gl.on("load",       () => pr("load"));
      gl.on("style.load", () => pr("style.load"));
      gl.on("idle",       () => pr("idle"));
      gl.on("movestart",  () => pr("movestart"));
      gl.on("move",       () => {/* zgomotos, lasă-l comentat dacă e prea mult */});
      gl.on("moveend",    () => pr("moveend"));
      gl.on("zoomstart",  () => pr("zoomstart"));
      gl.on("zoomend",    () => pr("zoomend"));
      gl.on("pitchstart", () => pr("pitchstart"));
      gl.on("pitchend",   () => pr("pitchend"));
      gl.on("rotatestart",() => pr("rotatestart"));
      gl.on("rotateend",  () => pr("rotateend"));
      gl.on("resize",     () => pr("resize", {size: gl.getContainer?.().getBoundingClientRect?.()}));
      gl.on("error",      (e) => console.warn("[MTK error]", e?.error || e));
    },
    debugAfterMapReady(mtkMap, t0) {
      try {
        const gl = mtkMap?.gl;
        const dur = Math.round(performance.now() - t0);
        const center = gl?.getCenter?.();
        const payload = {
          timeToIdleMs: dur,
          centerLng: center?.lng,
          centerLat: center?.lat,
          zoom: gl?.getZoom?.(),
          bearing: gl?.getBearing?.(),
          pitch: gl?.getPitch?.(),
          containerPx: gl?.getContainer?.()?.getBoundingClientRect?.(),
          dpr: window.devicePixelRatio || 1,
          styleLoaded: gl?.isStyleLoaded?.(),
        };
        console.groupCollapsed("%c[WeatherMTK] ✓ Map READY", "color:#0a0");
        console.table(payload);
        console.groupEnd();
      } catch (e) {
        console.warn("[WeatherMTK] debugAfterMapReady fail", e);
      }
    },
    async snapshot3DForPrint({ pxWidth, pxHeight }) {
      const map = this.mtkMap?.gl;
      if (!map?.getCanvas) throw new Error("3D map not ready");

      const container = map.getContainer();
      const canvas    = map.getCanvas();

      const dpr = window.devicePixelRatio || 1;
      const cssW = Math.round(pxWidth  / dpr);
      const cssH = Math.round(pxHeight / dpr);

      const oldW = container.style.width;
      const oldH = container.style.height;

      container.style.width  = cssW + "px";
      container.style.height = cssH + "px";
      map.resize();

      await new Promise(res => {
        const done = () => res();
        map.once("idle", done);
        map.triggerRepaint?.();
        // requestAnimationFrame(() => {}); 
      });

      let dataUrl;
      try {
        dataUrl = canvas.toDataURL("image/png"); 
      } catch (e) {
        console.error("toDataURL failed (tainted?)", e);
        const off = document.createElement("canvas");
        off.width = canvas.width;
        off.height = canvas.height;
        off.getContext("2d").drawImage(canvas, 0, 0);
        dataUrl = off.toDataURL("image/png");
      }

      container.style.width  = oldW || "";
      container.style.height = oldH || "";
      map.resize();

      return dataUrl;
    }
    ,
    getFitPadding() {
      const padding = { top: 150, right: 30, bottom: 80, left: 30 };
      console.log("[WeatherMTK] getFitPadding ->", padding);
      return padding;
    },
    fitBoundsWithPadding(bounds, extraOpts = {}) {
      if (!this.mtkMap?.gl?.fitBounds) {
        console.warn("[WeatherMTK] fitBoundsWithPadding: gl.fitBounds indisponibil");
        return;
      }
      const padding = this.getFitPadding();
      const opts = { padding, duration: 1200, ...extraOpts };
      this.mtkMap.gl.fitBounds(bounds, opts);
    },
    computeFeatureCenter(geometry) {
      if (!geometry) return null;
      if (geometry.type === "Point") return geometry.coordinates; 

      const b = new window.maplibregl.LngLatBounds();
      const push = (c) => b.extend(c);

      if (geometry.type === "LineString") geometry.coordinates.forEach(push);
      if (geometry.type === "MultiLineString") geometry.coordinates.flat().forEach(push);
      if (geometry.type === "Polygon") geometry.coordinates[0].forEach(push);
      if (geometry.type === "MultiPolygon") geometry.coordinates.flat(2).forEach(push);

      if (!b.isEmpty()) {
        const c = b.getCenter();
        return [c.lng, c.lat];
      }
      return null;
    },
    _quantize(n, dec = 4) {
      const p = Math.pow(10, dec);
      return Math.round(n * p) / p;
    },
    svgCircleDataUrl(color = "#00ff00", stroke = "black", r = 15) {
      const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
        <circle cx="50" cy="50" r="${r}" fill="${color}" stroke="${stroke}" stroke-width="5"/>
      </svg>`;
      return "data:image/svg+xml;base64," + btoa(svg);
    },
    handleFeatureFromList(feature) {
      const role = feature?.properties?.role;
      const type = feature?.geometry?.type;

      if (role === "street" && (type === "LineString" || type === "MultiLineString")) {
        this.addOrUpdateStreet(feature);
        return;
      }
      if (role === "hnr" && type === "Point") {
        this.addOrUpdateHnrMarker(feature);
        return;
      }
      this.focusOnPoi(feature); 
    },
    addOrUpdateStreet(feature) {
      const safe = this.normalizeFeatureCollection(feature);
      if (!safe || !safe.features.length) return;
      feature = safe.features[0];

      const geom = feature.geometry;
      if (!geom || !Array.isArray(geom.coordinates)) return;
      if (this.streetLineLayer3D) { this.streetLineLayer3D.remove(); this.streetLineLayer3D = null; }

      const color = feature.properties?.line_color || "#ff0000";
      const width = feature.properties?.width || 4;

      const polylines = [];
      const bounds = new window.maplibregl.LngLatBounds();

      const eachSegment = (geom.type === "LineString")
        ? [geom.coordinates]
        : geom.coordinates; 

      eachSegment.forEach(seg => {
        if (!Array.isArray(seg) || seg.length < 2) return;
        const pl = new MTK.Polyline({ color, width });
        pl.setLngLats(seg);
        seg.forEach(c => bounds.extend(c));
        polylines.push(pl);
      });

      if (!polylines.length) return;

      this.streetLineLayer3D = new MTK.CollectionLayer(MTK.Polyline);
      this.streetLineLayer3D.setLayers(polylines);
      this.streetLineLayer3D.addTo(this.mtkMap);


    const keyOf = ([lng, lat]) => {
        const r = (v) => Math.round(v * 1e5) / 1e5; // ~1m snap
        return `${r(lng)},${r(lat)}`;
      };
      const haversine = (a, b) => {
        const toRad = d => d * Math.PI / 180;
        const R = 6371000;
        const dLat = toRad(b[1]-a[1]);
        const dLng = toRad(b[0]-a[0]);
        const s1 = Math.sin(dLat/2), s2 = Math.sin(dLng/2);
        const aa = s1*s1 + Math.cos(toRad(a[1]))*Math.cos(toRad(b[1]))*s2*s2;
        return 2*R*Math.asin(Math.min(1, Math.sqrt(aa)));
      };

      const segments = eachSegment;
      const degree = new Map();
      const endpointsArray = [];

      segments.forEach(seg => {
        if (!Array.isArray(seg) || seg.length < 2) return;
        const a = seg[0], b = seg[seg.length - 1];
        const ka = keyOf(a), kb = keyOf(b);
        degree.set(ka, (degree.get(ka) || 0) + 1);
        degree.set(kb, (degree.get(kb) || 0) + 1);
        endpointsArray.push(a, b);
      });

      const leaves = endpointsArray.filter(p => (degree.get(keyOf(p)) || 0) % 2 === 1);
      const candidates = (leaves.length >= 2) ? leaves : endpointsArray;

      let bestA = candidates[0], bestB = candidates[0], bestD = -1;
      for (let i = 0; i < candidates.length; i++) {
        for (let j = i + 1; j < candidates.length; j++) {
          const d = haversine(candidates[i], candidates[j]);
          if (d > bestD) { bestD = d; bestA = candidates[i]; bestB = candidates[j]; }
        }
      }
      if (this.startMarker3D) { this.startMarker3D.remove(); this.startMarker3D = null; }
      if (this.stopMarker3D)  { this.stopMarker3D.remove();  this.stopMarker3D  = null; }

      this.startMarker3D = new MTK.Marker()
        .setLngLat(bestA)
        .setImage({ image: this.svgCircleDataUrl("#00ff00","black",15), size: 0.42, anchor: "center" })
        .addTo(this.mtkMap);

      this.stopMarker3D = new MTK.Marker()
        .setLngLat(bestB)
        .setImage({ image: this.svgCircleDataUrl("#ff0000","black",15), size: 0.42, anchor: "center" })
        .addTo(this.mtkMap);
      if (!bounds.isEmpty()) this.mtkMap.gl.fitBounds(bounds, { padding: 80, duration: 800, maxZoom: 18 });
    },
    addOrUpdateHnrMarker(feature) {
          const safe = this.normalizeFeatureCollection(feature);
if (!safe || !safe.features.length) return;
feature = safe.features[0];

    const pt = feature.geometry.coordinates;
    if (!Array.isArray(pt) || pt.length !== 2) return;

    if (this.hnrMarker3D) { this.hnrMarker3D.remove(); this.hnrMarker3D = null; }

    this.hnrMarker3D = new MTK.LabeledMarker({
      title: feature.properties?.name || "Număr"
    })
      .setLngLat(pt)
      .setImage({ id: "marker", anchor: "bottom", size: 1 }) // sau image: "https://…/hnr-pin.png"
      .addTo(this.mtkMap);

    // focus lejer pe marker, fără să dai jos linia
    // this.mtkMap.gl.flyTo({ center: pt, zoom: 19, speed: 0.7, curve: 1.6 });
    },
    webMercatorToWgs84([x, y]) {
      const R = 6378137;
      const lon = (x / R) * 180 / Math.PI;
      const lat = (2 * Math.atan(Math.exp(y / R)) - Math.PI / 2) * 180 / Math.PI;
      return [lon, lat];
    },
    isLikely3857([a, b]) {
      return Math.abs(a) > 180 || Math.abs(b) > 90;
    },
    maybeSwapLngLat([a, b]) {
      if (Math.abs(a) <= 90 && Math.abs(b) <= 180 && Math.abs(a) > Math.abs(b)) return [b, a];
      return [a, b];
    },
    normalizeCoord([x, y]) {
      if (this.isLikely3857([x, y])) return this.webMercatorToWgs84([x, y]);
      const [lng, lat] = this.maybeSwapLngLat([x, y]);
      if (isNaN(lng) || isNaN(lat) || Math.abs(lng) > 180 || Math.abs(lat) > 90) return null;
      return [lng, lat];
    },
    normalizeCoordsDeep(geom) {
      const fix = (c) => Array.isArray(c[0]) ? c.map(fix) : this.normalizeCoord(c);
      const prune = (arr) => Array.isArray(arr)
        ? arr.map(prune).filter(v => v !== null && !(Array.isArray(v) && v.length === 0))
        : arr;
      let coords = fix(JSON.parse(JSON.stringify(geom.coordinates)));
      coords = prune(coords);
      return { type: geom.type, coordinates: coords };
    },
    normalizeFeature(f) {
      if (!f?.geometry?.coordinates) return null;
      const geometry = this.normalizeCoordsDeep(f.geometry);
      const ok = Array.isArray(geometry.coordinates) && geometry.coordinates.length > 0;
      return ok ? { ...f, geometry } : null;
    },
    normalizeFeatureCollection(fc) {
      if (fc?.type === "Feature") {
        const one = this.normalizeFeature(fc);
        return { type: "FeatureCollection", features: one ? [one] : [] };
      }
      if (fc?.type === "FeatureCollection") {
        const features = fc.features.map(feat => this.normalizeFeature(feat)).filter(Boolean);
        return { type: "FeatureCollection", features };
      }
      return null;
    },
    normalizeSinglePoi(json) {
      log.start("normalizeSinglePoi() WeatherMTK.vue", { raw: json });

      if (json?.type === "Feature" && json?.geometry?.type && json?.geometry?.coordinates) {
        log.ok("e deja Feature valid");
        log.end(); return json;
      }

      if (json?.geometry?.type && json?.geometry?.coordinates) {
        log.ok("geometry la rădăcină → Feature");
        log.end(); return { type:"Feature", geometry: json.geometry, properties: json.properties || { ...json } };
      }
      if (json?.properties?.geometry?.type && json?.properties?.geometry?.coordinates) {
        log.ok("geometry în properties → Feature");
        log.end(); return { type:"Feature", geometry: json.properties.geometry, properties: { ...json.properties } };
      }

      if (json?.geom?.type && Array.isArray(json.geom.coordinates)) {
        const crsName = json.geom?.crs?.properties?.name || json.geom?.crs?.name || "";
        const is3857  = /3857|900913/i.test(crsName);
        log.ok(`geom detectat (crs=${crsName || "n/a"}, 3857=${is3857})`);
      }

      const lat = json?.lat ?? json?.latitude;
      const lng = json?.lng ?? json?.lon ?? json?.longitude;
      if (lat != null && lng != null) {
        log.ok("fallback lat/lng simplu");
        log.end(); return { type:"Feature", geometry:{ type:"Point", coordinates:[Number(lng), Number(lat)]}, properties:{ ...json }};
      }

      log.warn("NU s-a putut normaliza payload-ul la Feature");
      log.end(); return null;
    },
    _bearingFrom(a, b, fallback = 0) {
      if (!a || !b || a.length < 2 || b.length < 2) return fallback;

      const [lon1, lat1] = a;
      const [lon2, lat2] = b;

      const toRad = d => d * Math.PI / 180;
      const toDeg = r => r * 180 / Math.PI;

      const φ1 = toRad(lat1);
      const φ2 = toRad(lat2);
      const Δλ = toRad(lon2 - lon1);

      const y = Math.sin(Δλ) * Math.cos(φ2);
      const x = Math.cos(φ1) * Math.sin(φ2) -
                Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);

      let θ = toDeg(Math.atan2(y, x));
      if (Number.isNaN(θ)) θ = fallback;

      let bearing = (θ + 360) % 360;

      if (this._lastBearing == null) {
        this._lastBearing = bearing;
        return bearing;
      }
      const diff = ((bearing - this._lastBearing + 540) % 360) - 180;
      const alpha = 0.25;
      const smoothed = (this._lastBearing + diff * alpha + 360) % 360;

      this._lastBearing = smoothed;
      return smoothed;
    },
    _getElevAtIndex(elevData, i) {
      if (!elevData) return 0;
      if (Array.isArray(elevData?.samples)    && elevData.samples[i]?.elevation != null) return elevData.samples[i].elevation;
      if (Array.isArray(elevData?.points)     && elevData.points[i]?.elev       != null) return elevData.points[i].elev;
      if (Array.isArray(elevData?.elevations) && elevData.elevations[i]         != null) return elevData.elevations[i];
      return 0;
    },

    _haversine(a, b) {
      const toRad = d => d * Math.PI / 180;
      const R = 6371000;
      const dLat = toRad(b[1] - a[1]);
      const dLng = toRad(b[0] - a[0]);
      const s1 = Math.sin(dLat/2), s2 = Math.sin(dLng/2);
      const aa = s1*s1 + Math.cos(toRad(a[1]))*Math.cos(toRad(b[1]))*s2*s2;
      return 2 * R * Math.asin(Math.min(1, Math.sqrt(aa)));
    },

    _buildDistanceTable(coords) {
      const cum = [0];
      let total = 0;
      for (let i = 1; i < coords.length; i++) {
        total += this._haversine(coords[i-1], coords[i]);
        cum.push(total);
      }
      return { total, cum }; 
    },

    _pointAtDistance(coords, cum, d) {
      if (d <= 0) return coords[0];
      const last = cum[cum.length - 1];
      if (d >= last) return coords[coords.length - 1];
      let i = 1;
      while (i < cum.length && cum[i] < d) i++;
      const d0 = cum[i-1], d1 = cum[i];
      const t = (d - d0) / Math.max(1e-6, (d1 - d0)); // 0..1 pe segment [i-1, i]
      const a = coords[i-1], b = coords[i];
      return [ a[0] + (b[0]-a[0]) * t, a[1] + (b[1]-a[1]) * t ];
    },
    _fmtDuration(ms) {
      const s = Math.round(ms / 1000);
      const h = Math.floor(s / 3600);
      const m = Math.floor((s % 3600) / 60);
      const ss = s % 60;
      return [
        h ? `${h}h` : null,
        (m || h) ? `${m}m` : null,
        (!h && !m) ? `${ss}s` : null
      ].filter(Boolean).join(" ");
    },

    setupFlightControl(polyline = null) {

      console.log("setupFlightControl() called");

      if (!this.flightControl) {
        this.flightControl = new MTK.FlightControl();
        this.flightControl.addTo(this.mtkMap); 
        //nou26.01
        this._mountFlightControlToHost();


        this.flightControl.on("update", (event) => {
          const progress = event?.progress ?? 0;
          this.lastProgress = progress;

          if (this.elevationProfile?.updateFlightMarker) {
            this.elevationProfile.updateFlightMarker(progress);
          }

          if (progress >= 1 && !this.hasResetAfterFlight) {
            this.hasResetAfterFlight = true;
            setTimeout(() => {
              this.resetCameraTo2DNorth();
            }, 300);
          }
        });

        //nou 26.01 asta a fost scos
        // setTimeout(() => {
        //   const controlDiv = document.querySelector(".mtk-control-flight");
        //   if (controlDiv) {
        //     this.$root.$emit("mtkFlightControlReady", controlDiv);
        //   } else {
        //     console.warn("Not found.mtk-control-flight");
        //   }
        // }, 300);


      }

      if (polyline) {
        const marker = new MTK.Marker().setLngLat(polyline.lngLats[0]);
        marker.setImage({
          image: "data:image/svg+xml;base64," + btoa(`
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
              <circle cx="50" cy="50" r="15" fill="#00ff00" stroke="black" stroke-width="5"/>
            </svg>
          `),
          size: 0.42,
          anchor: "center"
        });

        this.flightControl.setPolyline(polyline);
        this.flightControl.setMarker(marker);

        // if (polyline?.lngLats?.length > 0 && this.mtkMap?.gl?.flyTo) {
        //   const centerIndex = Math.floor(polyline.lngLats.length / 2);
        //   const centerCoord = polyline.lngLats[centerIndex];

        //   this.mtkMap.gl.flyTo({
        //     center: centerCoord,
        //     zoom: 17,         
        //     speed: 0.2,      
        //     curve: 0.5,       
        //     pitch: 70,        
        //     bearing: 45 
        //   });

        //   console.log("Zoom in pe ruta FlightControl cu zoom 16 la coordonata:", centerCoord);
        // }

        if (this.elevationProfile?.setRouteFlight) {
          this.elevationProfile.setRouteFlight(this.flightControl);
        }

        console.log(" FlightControl: setat polyline și marker");
      }
    },
    emitFlightControlButton() {
      if (!this.flightControl || !this.flightControl._container) {
        console.warn("FlightControl not initialized or no DOM container");
        return;
      }
      const buttonElement = this.flightControl._container;
      this.$root.$emit("mtkFlightControlReady", buttonElement);
    },
    //nou26.01
createElevationProfile(polyline) {
  if (!polyline?.lngLats || polyline.lngLats.length < 2) return;

  // host trebuie să existe
  const host = this.elevationHostEl;
  if (!host) {
    // reîncearcă puțin mai târziu (race fix)
    setTimeout(() => this.ensureElevationProfile(), 120);
    return;
  }

  // curăță vechiul
  if (this.elevationProfile) {
    try { this.elevationProfile.remove(); } catch {console.error("Error loading profile")}
    this.elevationProfile = null;
  }

  this.elevationProfile = new MTK.ElevationProfile({ surface: true });

  this.elevationProfile.setPolyline(polyline, (err) => {
    if (err) { console.error("Error loading profile", err); return; }

    host.innerHTML = "";
    this.elevationProfile.addTo(host);
    this.elevationProfile.setMap?.(this.mtkMap);

    if (this.flightControl) {
      this.elevationProfile.setRouteFlight?.(this.flightControl);
    }

    // IMPORTANT: dacă UI-ul a fost montat în container, poate are nevoie de resize
    setTimeout(() => this.elevationProfile?.resize?.(), 0);
  });
}
,
    // createElevationProfile(polyline = null) {
    //   if (!polyline?.lngLats || polyline.lngLats.length < 2) return;
    //   if (this.elevationProfile) {
    //     try { this.elevationProfile.remove(); } catch {console.log("test");}
    //     this.elevationProfile = null;
    //   }

    //   try {
    //     this.elevationProfile = new MTK.ElevationProfile({ surface: true });

    //     this.elevationProfile.setPolyline(polyline, (err) => {
    //       if (err) { console.error("Error loading profile", err); return; }
    //       const host = document.querySelector(".height-profile");
    //       if (host) {
    //         this.elevationProfile.addTo(host);
    //         this.elevationProfile.setMap?.(this.mtkMap);

    //       } else {

    //         this.elevationProfile.addTo(this.mtkMap);
    //       }

    //       if (this.flightControl && this.elevationProfile?.setRouteFlight) {
    //         this.elevationProfile.setRouteFlight(this.flightControl);
    //       }
    //     });
    //   } catch (e) {
    //     console.error("General error in createElevationProfile:", e);
    //   }
    // },
    
    //nou26.01
    ensureElevationProfile() {
  if (!this.currentSelectedPolyline) return;
  if (!this.elevationHostEl) return;

  const alreadyMounted = !!this.elevationHostEl.querySelector(".mtk-elevation-profile");
  if (!this.elevationProfile || !alreadyMounted) {
    this.createElevationProfile(this.currentSelectedPolyline);
  } else {
    this.elevationProfile.setMap?.(this.mtkMap);
    this.elevationProfile.setRouteFlight?.(this.flightControl);
    this.elevationProfile.resize?.();
  }
}
,
    // ensureElevationProfile() {
    //   const host = document.querySelector(".height-profile");
    //   if (!this.currentSelectedPolyline || !host) return;

    //   const alreadyMounted = !!host.querySelector(".mtk-elevation-profile");
    //   if (!this.elevationProfile || !alreadyMounted) {
    //     this.createElevationProfile(this.currentSelectedPolyline);
    //   } else {
    //     this.elevationProfile.setMap?.(this.mtkMap);
    //     this.elevationProfile.setRouteFlight?.(this.flightControl);
    //     this.elevationProfile.resize?.();
    //   }
    // },
        
    //     createElevationProfilep(polyline) {
    //   if (!polyline || !polyline.lngLats || polyline.lngLats.length < 2) {
    //     console.warn("Invalid or too short polyline for elevation profile");
    //     return;
    //   }

    //   if (this.elevationProfile) {
    //     try {
    //       this.elevationProfile.remove();
    //     } catch (e) {
    //       console.warn("Error removing existing profile:", e);
    //     }
    //     this.elevationProfile = null;
    //   }

    //   try {
    //     this.elevationProfile = new MTK.ElevationProfile({ surface: true });

    //     console.log("Setting polyline with", polyline.lngLats.length, "points..");
    //     this.elevationProfile.setPolyline(polyline, (err, data) => {
    //       if (err) {
    //         console.error("Error loading profile", err);
    //         return;
    //       }
    //       console.log("Elevation profile successfully loaded, data:", data);
    //       this.elevationData = this.elevationProfile.getData();

    //       const fallbackContainer = document.querySelector(".height-profile");

    //       if (this.mtkMap && this.mtkMap.gl && typeof this.mtkMap.gl.getSource === "function") {
    //         this.elevationProfile.addTo(this.mtkMap);
    //         console.log(" ElevationProfile added on map MTK");
    //       } else if (fallbackContainer) {
    //         this.elevationProfile.addTo(fallbackContainer);
    //         console.log(" ElevationProfile added on container .height-profile");
    //       } else {
    //         console.warn(" Containerul .height-profile not found for fallback.");
    //       }

    //       setTimeout(() => {
    //         const fullProfileNode = document.querySelector(".mtk-elevation-profile");

    //         if (fullProfileNode) {
    //           this.$root.$emit("mtkElevationProfileReady", fullProfileNode);
    //         } else {
    //           console.warn(" .mtk-elevation-profile not found");
    //         }
    //       }, 300);
    //     });

    //   } catch (error) {
    //     console.error(" General error in createElevationProfile:", error);
    //   }
    // },


    enableWeatherLayer() {
      if (this.weatherActive || !this.mtkMap) return;
      this.weatherActive = true;
      // this.weatherControl.setWeather("overview");

      const et = document.querySelector(".mtk-daytime-control");
      if (et) {
        et.style.display = "block"; 
      }
      this._translateDaytimeSoon();
    },

    disableWeatherLayer() {
      if (!this.weatherActive) return;
      this.weatherControl = null;
      // this.weatherControl.setWeather("null");

      const group = document.querySelector(".mtk-weather-control-group");
      if (group) {
        const overviewBtn = group.querySelector(".mtk-weather-control-overview-button");
        overviewBtn?.click();
        group.style.display = "none";
      }

      const et = document.querySelector(".mtk-daytime-control");
        if (et) {
          et.style.display = "none"; 
      }
      
      
      this.weatherActive = false;
      this.$emit("updateWeatherState", false);
    },
    
    toggleWeatherLayer() {
      console.trace("toggleWeatherLayer() called");
      if (this.weatherActive) {
        this.disableWeatherLayer();
        // this.weatherControl.setWeather(null);
      } else {
        this.enableWeatherLayer();
        // this.weatherControl.setWeather("overview");
      }
      this.$emit("update:weatherActive", this.weatherActive);
      // this.weatherControl.setWeather(null);
    }, 
    toPlainCoords(coords) {
      if (Array.isArray(coords)) {
        return coords.map(c => this.toPlainCoords(c));
      }
      return coords;
    },

    addPoisOn3DMap(poisGeoJSON) {
      if (!this.mtkMap) {
        console.warn("mtkMap not exist!");
        return { ok: false };
      }

      const safe = this.normalizeFeatureCollection(poisGeoJSON);
      if (!safe || !safe.features.length) {
        console.warn("No valid features after normalization", poisGeoJSON);
        this.clearPOIsFromMap(false);
        return { ok: false };
      }
      poisGeoJSON = safe;
    
      if (this.poiLayer) { this.poiLayer.remove(); this.poiLayer = null; }
      if (this.geometryLineLayer) { this.geometryLineLayer.remove(); this.geometryLineLayer = null; }
      if (this.geometryPolygonLayer) { this.geometryPolygonLayer.remove(); this.geometryPolygonLayer = null; }
      if (this.startMarker3D) { this.startMarker3D.remove(); this.startMarker3D = null; }
      if (this.stopMarker3D)  { this.stopMarker3D.remove();  this.stopMarker3D  = null; }
      this.currentSelectedPolyline = null;

      const markers = [];
      const polylines = [];
      const polygons  = [];
      const allCoords = [];

      const boundsAll = new window.maplibregl.LngLatBounds();

      poisGeoJSON.features.forEach((f) => {
        const g = f.geometry;
        if (!g) return;

        const name = f.properties?.name || "POI";

        // — Point
        if (g.type === "Point") {
          const [lng, lat] = g.coordinates;
          allCoords.push([lng, lat]);
          boundsAll.extend([lng, lat]);

          const marker = new MTK.LabeledMarker({
            title: name,
            subtitle: f.properties?.subtitle || ""
          }).setLngLat([lng, lat]);

          let imgUrl = f.properties?.icon;
          if (imgUrl && !imgUrl.startsWith("http")) {
            imgUrl = "https://map.map2web.eu" + imgUrl;
          }
          marker.setImage(
            imgUrl
              ? { image: imgUrl, size: 1, anchor: "bottom" }
              : { image: this.svgCircleDataUrl("#0000ff"), size: 1, anchor: "bottom" }
          );
          marker.on?.("mouseover", (e) => this._showHoverTooltip(name, e));
          marker.on?.("mousemove", (e) => this._moveHoverTooltip(e));
          marker.on?.("mouseout",  () => this._hideHoverTooltip());
          marker.on?.("click", () => this.focusFeatureOnce(f));
          markers.push(marker);
        }

        // — LineString
        if (g.type === "LineString") {
          g.coordinates.forEach(c => { allCoords.push(c); boundsAll.extend(c); });

          const polyline = new MTK.Polyline({
            color: f.properties?.line_color || "#ff0000",
            width: f.properties?.width || 3,
            clickable: true
          });
          polyline.setLngLats(g.coordinates);
          polyline.on?.("mouseover", (e) => this._showHoverTooltip(name, e));
          polyline.on?.("mousemove", (e) => this._moveHoverTooltip(e));
          polyline.on?.("mouseout",  () => this._hideHoverTooltip());
          polyline.on?.("click", () => this.focusFeatureOnce(f));
          polylines.push(polyline);

          // Start/Stop
          if (g.coordinates.length >= 2) {
            this.startMarker3D = new MTK.LabeledMarker({ title: "Start" })
              .setLngLat(g.coordinates[0]).addTo(this.mtkMap);
            this.stopMarker3D = new MTK.LabeledMarker({ title: "Stop" })
              .setLngLat(g.coordinates[g.coordinates.length - 1]).addTo(this.mtkMap);
          }
        }

        // — MultiLineString
        if (g.type === "MultiLineString") {
          g.coordinates.forEach(line => {
            line.forEach(c => { allCoords.push(c); boundsAll.extend(c); });
            const polyline = new MTK.Polyline({
              color: f.properties?.line_color || "#ff0000",
              width: f.properties?.width || 3,
              clickable: true
            });
            polyline.setLngLats(line);
            polyline.on?.("mouseover", (e) => this._showHoverTooltip(name, e));
            polyline.on?.("mousemove", (e) => this._moveHoverTooltip(e));
            polyline.on?.("mouseout",  () => this._hideHoverTooltip());
            polyline.on?.("click", () => this.focusFeatureOnce(f));
            polylines.push(polyline);
          });
        }

        // — Polygon
        if (g.type === "Polygon") {
          g.coordinates.forEach(ring => ring.forEach(c => { allCoords.push(c); boundsAll.extend(c); }));
          const polygon = new MTK.Polygon({
            fillColor: f.properties?.fill_color || "#00ff00",
            fillOpacity: f.properties?.fill_opacity ?? 0.5,
            lineColor: f.properties?.line_color || "#000000",
            lineWidth: f.properties?.width || 2
          });
          polygon.setLngLats(g.coordinates);
          polygon.on?.("mouseover", (e) => this._showHoverTooltip(name, e));
          polygon.on?.("mousemove", (e) => this._moveHoverTooltip(e));
          polygon.on?.("mouseout",  () => this._hideHoverTooltip());
          polygon.on?.("click", () => this.focusFeatureOnce(f));
          polygons.push(polygon);
        }

        // — MultiPolygon
        if (g.type === "MultiPolygon") {
          g.coordinates.forEach(poly => {
            poly.forEach(ring => ring.forEach(c => { allCoords.push(c); boundsAll.extend(c); }));
            const polygon = new MTK.Polygon({
              fillColor: f.properties?.fill_color || "#00ff00",
              fillOpacity: f.properties?.fill_opacity ?? 0.3,
              lineColor: f.properties?.line_color || "#000000",
              lineWidth: f.properties?.width || 1
            });
            polygon.setLngLats(poly);
            polygon.on?.("mouseover", (e) => this._showHoverTooltip(name, e));
            polygon.on?.("mousemove", (e) => this._moveHoverTooltip(e));
            polygon.on?.("mouseout",  () => this._hideHoverTooltip());
            polygon.on?.("click", () => this.focusFeatureOnce(f));
            polygons.push(polygon);
          });
        }
      });

      // add layers
      if (markers.length) {
        this.poiLayer = new MTK.CollectionLayer(MTK.LabeledMarker, {
          states: { hover: { paint: { "text-color": "#00f" } } }
        });
        this.poiLayer.setLayers(markers).addTo(this.mtkMap);
      }
      if (polylines.length) {
        this.geometryLineLayer = new MTK.CollectionLayer(MTK.Polyline);
        this.geometryLineLayer.setLayers(polylines).addTo(this.mtkMap);
      }
      if (polygons.length) {
        this.geometryPolygonLayer = new MTK.CollectionLayer(MTK.Polygon);
        this.geometryPolygonLayer.setLayers(polygons).addTo(this.mtkMap);
      }
    },

    focusMapAfterAdding(ctx, opts = {}) {
      if (!ctx?.ok || !this.mtkMap?.gl) return;

      const gl = this.mtkMap.gl;
      const {
        paddingMulti = 150,
        durationMulti = 1000,
        paddingSingle = 100,
        durationSingle = 1600,
        speedPoint = 4,
        curvePoint = 1.05
      } = opts;

      if (ctx.featuresCount > 1 && ctx.boundsAll) {
        this._fittingNow = true; this.skipNextAutoFit = true;
        gl.fitBounds(ctx.boundsAll, { padding: paddingMulti, duration: durationMulti });
        gl.once("moveend", () => setTimeout(() => { this._fittingNow = false; this.skipNextAutoFit = false; }, 100));
        return;
      }

      const feature  = ctx.firstFeature;
      const geometry = feature?.geometry;
      if (!geometry) return;

      const bounds = new window.maplibregl.LngLatBounds();
      let moved = false;

      // — Point → flyTo with zoom 
      if (geometry.type === "Point") {
        const [lng, lat] = geometry.coordinates;
        this._fittingNow = true; this.skipNextAutoFit = true;
        gl.flyTo({
          center: [lng, lat],
          zoom: 13,
          speed: speedPoint,
          curve: curvePoint
        });
        gl.once("moveend", () => setTimeout(() => { this._fittingNow = false; this.skipNextAutoFit = false; }, 100));
        return;
      }

      // — LineString
      if (geometry.type === "LineString") {
        geometry.coordinates.forEach(c => bounds.extend(c));
        this.currentSelectedPolyline = new MTK.Polyline({
          color: feature.properties?.line_color || "#ff0000",
          width: feature.properties?.width || 3
        });
        this.currentSelectedPolyline.setLngLats(geometry.coordinates);
        this.createElevationProfile?.(this.currentSelectedPolyline);
        this.setupFlightControl?.(this.currentSelectedPolyline);

      }

      // — MultiLineString
      if (geometry.type === "MultiLineString") {
        const flatCoords = geometry.coordinates.flat();
        flatCoords.forEach(c => bounds.extend(c));
        this.currentSelectedPolyline = new MTK.Polyline({
          color: feature.properties?.line_color || "#ff0000",
          width: feature.properties?.width || 3
        });
        this.currentSelectedPolyline.setLngLats(flatCoords);
        this.createElevationProfile?.(this.currentSelectedPolyline);
        this.setupFlightControl?.(this.currentSelectedPolyline);

        if (!bounds.isEmpty()) {
          this._fittingNow = true; this.skipNextAutoFit = true;
          gl.fitBounds(bounds, {
            padding: paddingSingle,
            duration: durationSingle,
            linear: false,
            easing: t => 1 - Math.pow(1 - t, 2)
          });
          gl.once("moveend", () => setTimeout(() => { this._fittingNow = false; this.skipNextAutoFit = false; }, 100));
          moved = true;
        }
      }

      // — Polygon
      if (geometry.type === "Polygon") {
        geometry.coordinates.forEach(ring => ring.forEach(c => bounds.extend(c)));
      }

      // — MultiPolygon
      if (geometry.type === "MultiPolygon") {
        geometry.coordinates.forEach(poly => poly.forEach(ring => ring.forEach(c => bounds.extend(c))));
      }

      // Fallback comun (Poligon / MultiPoligon sau cazuri neacoperite)
      if (!moved && !bounds.isEmpty()) {
        this._fittingNow = true; this.skipNextAutoFit = true;
        gl.fitBounds(bounds, {
          padding: paddingSingle,
          duration: durationSingle,
          linear: false,
          easing: t => 1 - Math.pow(1 - t, 2)
        });
        gl.once("moveend", () => setTimeout(() => { this._fittingNow = false; this.skipNextAutoFit = false; }, 100));
      }
    },

    renderPoisAndFocus(poisGeoJSON) {
      const ctx = this.addPoisOn3DMap(poisGeoJSON);
      this.focusMapAfterAdding(ctx, {
        paddingMulti: 150,
        durationMulti: 1000,
        paddingSingle: 100,
        durationSingle: 1600,
      });
    },
    
    async focusOnPoi(feature) {
      const safe = this.normalizeFeatureCollection(feature);
      if (!safe || !safe.features.length) return;
      feature = safe.features[0];

      if (!this.mtkMap || !feature?.geometry?.coordinates) {
        console.warn("WeatherMTK: Map or feature is missing");
        return;
      }

      this.clearPOIsFromMap(false); 
      await this.$nextTick();
      this.skipNextAutoFit = false; 
      setTimeout(() => {
        this.addPoisOn3DMap({
          type: "FeatureCollection",
          features: [feature],
        });
        
      }, 100); 
    },
    _canAutoMoveCamera(reason = "") {
      if (this.cameraBusy) { 
        console.log("[cam] BUSY → skip", { reason }); 
        return false; 
      }
      if (this.skipNextAutoFit) {
        console.log("[cam] skipNextAutoFit → skip", { reason });
        this.skipNextAutoFit = false; 
        return false;
      }
      return true;
    },
    _withCameraLock(doMove) {
      if (this.cameraBusy) return;
      this.cameraBusy = true;
      try {
        const ret = doMove?.();
        requestAnimationFrame(() => { this.cameraBusy = false; });
        return ret;
      } catch(e) {
        this.cameraBusy = false;
        throw e;
      }
    },

    clearPOIsFromMap() {
      // if (!this.mtkMap || typeof this.mtkMap.getLayers !== "function") {
      //   console.warn(" mtkMap or getLayers is not available");
      //   return;
      // }
      if (!this.mtkMap) return;
      this.poiLayer?.off?.("mouseover");
      this.poiLayer?.off?.("mouseout");
      this.geometryLineLayer?.off?.("mouseover");
      this.geometryLineLayer?.off?.("mouseout");
      this.geometryPolygonLayer?.off?.("mouseover");
      this.geometryPolygonLayer?.off?.("mouseout");
      if (this.poiLayer) { this.poiLayer.remove(); this.poiLayer = null; }
      if (this.geometryLineLayer) { this.geometryLineLayer.remove(); this.geometryLineLayer = null; }
      if (this.geometryPolygonLayer) { this.geometryPolygonLayer.remove(); this.geometryPolygonLayer = null; }
      if (this.flightPolylineLayer) { this.flightPolylineLayer.remove(); this.flightPolylineLayer = null; }

      this.isSingleLineSelected = false;
      if (this.hnrMarker3D) { this.hnrMarker3D.remove(); this.hnrMarker3D = null; }
      if (this.startMarker3D) { this.startMarker3D.remove(); this.startMarker3D = null; }
      if (this.stopMarker3D)  { this.stopMarker3D.remove();  this.stopMarker3D  = null; }
      if (this.streetLineLayer3D)  { this.streetLineLayer3D.remove();  this.streetLineLayer3D  = null; }
      if (this.currentSelectedPolyline) { this.currentSelectedPolyline.remove(); this.currentSelectedPolyline = null; }

//       if (this.geolocationMarker) {
//   try { this.geolocationMarker.remove?.(); } catch (e){console.warn("Failed to remove geolocation marker", e);}
//   this.geolocationMarker = null;
// }

    },
    close3DMapWeather() {
      if (this.mtkMap?.gl) {
        const center = this.mtkMap?.gl.getCenter();
        const zoom = this.mtkMap?.gl.getZoom();
        console.log("close3DMapWeather =>> Coordinates sent on map close:", {
          lat: center.lat,
          lng: center.lng,
          zoom
        });

        this.$emit("close3D", {
          lat: center.lat,
          lng: center.lng,
          zoom
        });
      } else {
        this.$emit("close3DWeather");
      }
      this.isWeatherLayerMounted = false;
      this.$emit("closeWeather");
    },
    getCurrentView() {
      const gl = this.mtkMap?.gl;
      if (!gl) return null;
      const c = gl.getCenter();
      console.log(c);
      return { lat: c.lat, lng: c.lng, zoom: gl.getZoom() };
    },
    async loadAllPoisFromBackend() {
      try {
        const base = M2wApi.host_address.replace(/\/+$/, "");
        const response = await fetch(`${base}/api/pois`);

        const contentType = response.headers.get("content-type");
        const raw = await response.text();

        if (!response.ok) {
          console.error(`Error HTTP ${response.status}:`, raw);
          throw new Error("Server response is not OK.");
        }

        if (!contentType || !contentType.includes("application/json")) {
          console.error("Response is not valid JSON. Type:", contentType);
          console.warn("Raw response received:", raw);
          throw new Error("Response is not of type JSON.");
        }

        let allPois = JSON.parse(raw);

        if (!allPois || allPois.type !== "FeatureCollection") {
          console.warn("Invalid POI data:", allPois);
          return;
        }


        const BASE_ICON_URL = M2wApi.host_address;
        const features = allPois.features.map((feature) => {
          const rawIconId = feature.properties?.icon_id || feature.properties?.icon || null;
          const safeIconId = rawIconId ? rawIconId.replace(/^.*[\\/]/, "") : null;

          let iconUrl = null;
          if (feature.properties?.icon) {
            iconUrl = feature.properties.icon.startsWith("http")
              ? feature.properties.icon
              : BASE_ICON_URL + feature.properties.icon;
          }

          return {
            ...feature,
            properties: {
              ...feature.properties,
              icon: iconUrl,
              icon_id: safeIconId
            }
          };
        });

        allPois = {
          type: "FeatureCollection",
          features
        };
        this.addPoisOn3DMap(allPois);
        console.log("apelare addPois din functia loadAllpois");

      } catch (error) {
        console.error(" Failed to load POIs from backend:", error);
      }
    }, 
    startRouting() {
      console.log("Start Routing...");
      // add routing for POIs on MTK
    },
    triggerGeolocation() {
  const mtkMap = this.mtkMap;
  if (!mtkMap || !mtkMap.gl) {
    console.warn("MTK map is not ready or missing .gl reference");
    return;
  }

  // ✅ CLICK #2 => șterge pinul și ieși
  if (this.geolocationMarker) {
    try {
      this.geolocationMarker.remove?.();
    } catch (e) {
      console.warn("Failed to remove geolocation marker:", e);
    }
    this.geolocationMarker = null;
    return;
  }

  const maplibregl = window.maplibregl || window.MTK?.maplibregl;
  if (!maplibregl) {
    console.error("maplibregl is not available");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (pos) => {
      const { latitude, longitude } = pos.coords;

      const sw = new maplibregl.LngLat(longitude - 0.01, latitude - 0.01);
      const ne = new maplibregl.LngLat(longitude + 0.01, latitude + 0.01);
      const bounds = new maplibregl.LngLatBounds(sw, ne);

      const marker = new MTK.LabeledMarker({
        title: "Locatia ta",
        subtitle: new Date().toLocaleTimeString()
      }).setLngLat([longitude, latitude]);

      marker.setImage({ id: "marker", anchor: "bottom", size: 1 });
      marker.addTo(mtkMap);

      // ✅ salvează referința, ca să poți șterge la click #2
      this.geolocationMarker = marker;

      try {
        mtkMap.gl.fitBounds(bounds, { padding: 40, duration: 1000 });
      } catch (err) {
        console.error("Error during fitBounds", err);
      }
    },
    (err) => {
      console.error("Geolocation error:", err);
    },
    { enableHighAccuracy: true }
  );
},

    // triggerGeolocation() {

    //   const mtkMap = this.mtkMap;
    //   if (!mtkMap || !mtkMap.gl) {
    //     console.warn("MTK map is not ready or missing .gl reference");
    //     return;
    //   }

    //   const maplibregl = window.maplibregl || window.MTK?.maplibregl;
    //   if (!maplibregl) {
    //     console.error("maplibregl is not available");
    //     return;
    //   }

    //   navigator.geolocation.getCurrentPosition(
    //     (pos) => {
    //       const { latitude, longitude } = pos.coords;
    //       console.log("Pozition:", latitude, longitude);

    //       const sw = new maplibregl.LngLat(longitude - 0.01, latitude - 0.01);
    //       const ne = new maplibregl.LngLat(longitude + 0.01, latitude + 0.01);
    //       const bounds = new maplibregl.LngLatBounds(sw, ne);

    //       console.log("fitBounds with:", bounds.toArray());

    //       // Created marker on map
    //       const marker = new MTK.LabeledMarker({
    //         title: "Locatia ta",
    //         subtitle: new Date().toLocaleTimeString()
    //       }).setLngLat([longitude, latitude]);

    //       marker.setImage({
    //         id: "marker", 
    //         anchor: "bottom",
    //         size: 1
    //       });
    //       marker.addTo(mtkMap);
    //       this.geolocationMarker = marker;

    //       try {
    //         mtkMap.gl.fitBounds(bounds, {
    //           padding: 40,
    //           duration: 1000,
    //         });
    //       } catch (err) {
    //         console.error("Error during fitBounds", err);
    //       }
    //     },
    //     (err) => {
    //       console.error("Geolocation error:", err);
    //     },
    //     {
    //       enableHighAccuracy: true,
    //     }
    //   );
    // },
    _showHoverTooltip(text, e) {
  if (!text) return;

  // MTK / MapLibre trimit uneori event-ul în originalEvent
  const oe = e?.originalEvent || e;

  const x = oe?.clientX ?? 0;
  const y = oe?.clientY ?? 0;

  this.hoverTooltip.text = text;
  this.hoverTooltip.x = x + 12;   // mic offset față de cursor
  this.hoverTooltip.y = y + 12;
  this.hoverTooltip.visible = true;

  // cursor pointer
  const canvas = this.mtkMap?.gl?.getCanvas?.();
  if (canvas) canvas.style.cursor = "pointer";
},

_moveHoverTooltip(e) {
  if (!this.hoverTooltip.visible) return;

  const oe = e?.originalEvent || e;
  const x = oe?.clientX ?? 0;
  const y = oe?.clientY ?? 0;

  this.hoverTooltip.x = x + 12;
  this.hoverTooltip.y = y + 12;
},

_hideHoverTooltip() {
  this.hoverTooltip.visible = false;

  const canvas = this.mtkMap?.gl?.getCanvas?.();
  if (canvas) canvas.style.cursor = "";
},

  }
};

function installNoZoomWhileDragging(gl, getZoom, setZoom) {
  let dragging = false;
  let zoomAtDragStart = null;
  const disableZoomers = () => { 
    gl.scrollZoom.disable(); 
    // gl.touchZoomRotate.disable();
    gl.doubleClickZoom.disable();
    gl.boxZoom.disable(); };
  const enableZoomers = () => {
    gl.scrollZoom.enable(); 
    // gl.touchZoomRotate.enable(); 
    gl.doubleClickZoom.enable(); 
    gl.boxZoom.enable(); };

  gl.on("dragstart", () => {
    dragging = true;
    zoomAtDragStart = getZoom();
    disableZoomers();
  });

  gl.on("dragend", () => {
    dragging = false;
    enableZoomers();
    const z = getZoom();
    if (Math.abs(z - zoomAtDragStart) > 1e-6) setZoom(zoomAtDragStart);
  });

  gl.on("zoomstart", () => {
    if (dragging) {
      gl.stop();
      setZoom(zoomAtDragStart);
    }
  });
}

function installPanFlags(gl, setFlag) {
  gl.on("dragstart", () => setFlag(true));
  gl.on("dragend", () => setFlag(false));
}



</script>

<style scoped>
#weather-map-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1; 
  background: #000;
  pointer-events: auto;
}

#weather-map-container {
  width: 100%;
  height: 100%;
  pointer-events: auto;
}

.weather-icon-button {
  position: absolute;
  bottom: 10px;
  right: 15px;
  z-index: 1000;
  background-color: #ffffff;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
}

.weather-icon-button:hover {
  background-color: rgb(255, 255, 255);
}

.weather-icon-button .material-icons-round {
  font-size: 24px;
}
/* #weather-map-container {
  background-color: #87CEFA !important; 
  background: linear-gradient(to bottom, #a3d8fd 0%, #b0e2ff 10%, #f0f8ff 30%) !important;
} */

#weather-map-container {
  transition: background 0.6s ease-in-out;
}

.hover-tooltip {
  position: fixed;
  z-index: 99999;
  pointer-events: none;
  background: #ecf0f3;
  padding: 6px 10px;
  border: 1px solid #a9a9a9;
  box-shadow: 1px 3px 3px #999999;
  border-radius: 8px;
  /* max-width: 260px; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-family: Quicksand, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #464646;
  line-height: 1.2em;
  letter-spacing: 0.03em;
  text-align: left;
  flex: 1;
}


</style>

<style>
#weather-map-container .mtk-control-styles-top-right {
  margin-top: 70px;
  margin-right: 15px;
  z-index: 10; 
}
@media (max-width: 768px) {
  #weather-map-container .mtk-control-styles-top-right {
    display: none !important;
  }
}

#weather-map-container  .maplibregl-canvas-container {
  background-color: #87CEFA !important; /* cer albastru deschis */
}

#weather-map-container .maplibregl-ctrl-attrib-inner{
  display: none;
}

#weather-map-container .mtk-control-logo{
  display: none;
}

@media (max-width: 768px) {
  #weather-map-container .mapboxgl-ctrl-attrib {
    display: none !important;
  }
}

#weather-map-container .maplibregl-ctrl-bottom-right  {
  /* frontend2-base dezactivat stilul de mai jos*/
  margin-bottom: 205px; 
  /* frontend2-base activat stilul de mai jos*/
  /* margin-bottom: 168px; */
  margin-right: -6px;
  z-index: 10; 
}
@media (min-width: 400px) and (max-width: 769px) {
  #weather-map-container .mtk-3d-control {
    background-color: #ecf0f3;
    margin-bottom: 20px;
  }
}
#weather-map-container .mtk-3d-control{
    background-color: #ecf0f3;
    border: 1px solid #a9a9a9;
    box-shadow: 1px 3px 3px #999999;
    margin-bottom: 20px;
    border-radius: 8px;
    
  }

@media (max-width: 599px) {
  #weather-map-container .maplibregl-ctrl-bottom-right {
    margin-bottom: 175px;
  }
}

#weather-map-container  .mtk-control-styles-current{
  font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-weight: 600;
        color: #464646;
        line-height: 1.2em;
        letter-spacing: 0.03em;
        text-align: left;
        flex: 1;
        
}

#weather-map-container .mtk-control-styles-groups-active{
  font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-weight: 600;
        color: #464646;
        line-height: 1.2em;
        letter-spacing: 0.03em;
        text-align: left;
        flex: 1;
        
}

#weather-map-container  .mtk-control-styles-group-list-item-name{
  font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-weight: 400;
        color: #464646;
        line-height: 1.2em;
        letter-spacing: 0.03em;
        text-align: left;
        flex: 1;
        
        

}

#weather-map-container  .mtk-control-styles-expand{
  font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-weight: 400;
        color: #464646;
        line-height: 1.2em;
        letter-spacing: 0.03em;
        text-align: left;
        flex: 1;
        
}
#weather-map-container .mtk-control-styles-groups-active{
  padding: 0px;
    border: 1px solid #a9a9a9;
    box-shadow: 1px 3px 3px #9999;
  }

#weather-map-container .mtk-control-styles {
    border: 1px solid #a9a9a9;
    box-shadow: 1px 3px 3px #9999;
}


#weather-map-container .mtk-weather-control-group{
  display: none;
  margin-top: 10px;
  margin-right: 15px;
  padding: 3.3px;
  border-radius: 10px;
  z-index: 10; 
  border: 1px solid #a9a9a9;
    box-shadow: 1px 3px 3px #9999;
}

@media (max-width: 768px) {
  #weather-map-container .mtk-weather-control-group {
    display: none!important; 
  }
}

#weather-map-container .mtk-scale-control{
  display: none!important; 
  margin-right: 15px;
  border-radius: 10px;
}

#weather-map-container .mtk-elevation-svg{
display: none;
  /* background-color: aqua; */
}
#weather-map-container .mtk-compass-control-label{
  font-family: Quicksand, sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #464646;
  line-height: 1.2em;
  letter-spacing: 0.03em;
  text-align: center;
  flex: 1;
}

#weather-map-container .mtk-3d-control button {
    font-family: Quicksand, sans-serif;
    background-color: #ecf0f3;
    padding: 20px 20px;
    font-size: 16px;
    font-weight: 900;
    line-height: 1.2;
    border-radius: 12px;
    border: none;
    cursor: pointer;
    color: #444;
    display: flex;
    align-items: center;
    justify-content: center;
  }

#weather-map-container .mtk-daytime-control .mtk-daytime-control-0-button{
        font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-weight: 600;
        color: #464646;
        line-height: 1.2em;
        letter-spacing: 0.03em;
        text-align: left;
        flex: 1;
        
}

#weather-map-container .mtk-daytime-control .mtk-daytime-control-1-button{
        font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-weight: 600;
        color: #464646;
        line-height: 1.2em;
        letter-spacing: 0.03em;
        text-align: left;
        flex: 1;
}
#weather-map-container .mtk-daytime-control .mtk-daytime-control-2-button{
        font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-weight: 600;
        color: #464646;
        line-height: 1.2em;
        letter-spacing: 0.03em;
        text-align: left;
        flex: 1;
}
#weather-map-container .mtk-daytime-control .mtk-daytime-control-3-button{
        font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-weight: 600;
        color: #464646;
        line-height: 1.2em;
        letter-spacing: 0.03em;
        text-align: left;
        flex: 1;
}
#weather-map-container .mtk-daytime-control .mtk-daytime-control-4-button{
        font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-weight: 600;
        color: #464646;
        line-height: 1.2em;
        letter-spacing: 0.03em;
        text-align: left;
        flex: 1;
}

#weather-map-container .mtk-daytime-control{
        font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-weight: 600;
        color: #464646;
        line-height: 1.2em;
        letter-spacing: 0.03em;
        text-align: left;
        flex: 1;
        border: 1px solid #a9a9a9;
    box-shadow: 1px 3px 3px #9999;
}

#weather-map-container .mtk-compass-control{
  margin-top: 70px;
  margin-right: 15px;
  background-color: #ecf0f3;
  font-family: Quicksand, sans-serif;
  
}

#weather-map-container .mtk-pitch-control .mtk-pitch-control-slide{
  background-color: #ecf0f3;
  font-family: Quicksand, sans-serif;
}
@media (max-width: 768px) {
  #weather-map-container .mtk-pitch-control{
    display: none!important; 
    
  }
}

@media (max-width: 768px){#weather-map-container .mtk-3d-control {
    background-color: #ecf0f3;
    border: 1px solid #a9a9a9;
    box-shadow: 1px 3px 3px #999999;
    margin-bottom: 25px;
    border-radius: 8px;
}}

#weather-map-container .maplibregl-ctrl-group-inline{
  background-color: #ecf0f3;
  padding: 3.3px;
  border-radius: 10px;
  
}


#weather-map-container .mtk-control-flight-button .mtk-control-flight{
  display: none;
  /* margin-top: 170px; */
}


#weather-map-container .mtk-control-flight{
  /* margin-top: 170px; */
   /* display: none; */
}

@media (max-height: 700px), (max-width: 500px) {
 #weather-map-container  .mtk-control-styles-current {
    display: none !important;
  }
}
@media (max-height: 700px), (max-width: 500px) {
 #weather-map-container  .mtk-pitch-control {
    display: none !important;
  }
}

@media (orientation: landscape) and (max-width: 900px) {
  #weather-map-container .mtk-3d-control,
  #weather-map-container .mtk-compass-control,
  #weather-map-container .mtk-pitch-control,
  #weather-map-container .mtk-control-styles,
  #weather-map-container .mtk-daytime-control,
  #weather-map-container .mtk-weather-control-group,
  #weather-map-container .maplibregl-ctrl-bottom-right,
  #weather-map-container .maplibregl-ctrl-top-right {
    display: none !important;
  }
}

.flight-host .mtk-control-flight { display: block !important; }



</style>

